import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitcherComponent } from './switcher.component';
import { SwitcherGroupComponent } from './switcher-group.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
  ],
  declarations: [
    SwitcherComponent,
    SwitcherGroupComponent,
  ],
  exports: [
    SwitcherComponent,
    SwitcherGroupComponent,
  ]
})
export class SwitcherModule {}
